import { createAxiosClient } from "@/shared/axios/axios";
import { handleAxiosError } from "@/shared/helper";
import type { Container } from "@/app/fbs-hub-app/shared/@types/backend";

export const getContainers = async ({
  userId,
  customerId,
}: {
  userId: string;
  customerId: string;
}) => {
  let data = undefined;

  try {
    const client = await createAxiosClient();
    const response = await client.get(
      `/users/${userId}/accounts/${customerId}/fbs/containers`,
    );
    data = response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }

  return data.containers as Array<Container>;
};
